import { createSelector } from 'reselect';
import { oc } from 'ts-optchain';

import { BusinessAndRole } from 'types';
import { StoreType } from '@tock/shared/utils/connect';
import { core } from '@tock/coretypes';
import { filterNilValues } from '@tock/shared/utils/typeUtils';
import { map } from 'es-toolkit/compat';

export const businessSelector = (state: StoreType) => state.business.data;

export default createSelector(
  (state: StoreType) => {
    return oc(state.app).allBusinessRoles(); // This should exist but doesn't always in tests
  },
  (allBusinessRoles): BusinessAndRole[] => {
    return map(allBusinessRoles, (businessRole) => ({
      ...(businessRole.business as core.Business),
      roles: businessRole.role,
    }));
  }
);

export const teamMemberPatronsSelector = createSelector(
  (state: StoreType) => state.app?.patron,
  (state: StoreType) => state.businessRoles.roles,
  (loggedinPatron: core.IPatron, roles: core.AssignedPatronRole[]): core.IPatron[] =>
    roles
      .map((assignedRole) => assignedRole.patron || undefined)
      .filter((patron) => {
        // Filter out the role list, only display Tock roles if the logged in user is a Tock employee
        const isTockUser = loggedinPatron?.isTockEmployee;
        return isTockUser || !patron?.isTockEmployee;
      })
      .filter(filterNilValues)
);

export const activePatronBusinessRoleSelector = createSelector(
  (state: StoreType) => state.app.allBusinessRoles,
  (state: StoreType) => state.app.activeBusiness?.id,
  (
    businessRoles: core.AuthBusinessResponse[],
    businessId?: number
  ): core.AuthBusinessResponse | undefined =>
    businessId ? businessRoles.find((role) => role.business?.id === businessId) : undefined
);

export const businessTaxesSelector = createSelector(
  (state: StoreType) => state.business.businessTaxes,
  (businessTaxes) => businessTaxes
);
